import { Controller } from "@hotwired/stimulus"

// Generic add/remove for nested form rows using a <template> target.
export default class extends Controller {
  static targets = ["container", "template", "row"]

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now().toString())
    this.containerTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()
    const row = event.currentTarget.closest("[data-nested-form-target='row']")
    if (!row) return

    const destroyInput = row.querySelector("input[name*='_destroy']")
    if (destroyInput) {
      destroyInput.value = "1"
      row.classList.add("hidden")
    } else {
      row.remove()
    }

    // Keep at least one visible row so the form never looks empty.
    const visible = this.rowTargets.filter((r) => !r.classList.contains("hidden"))
    if (visible.length === 0) this.add(event)
  }
}
